import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const getRedemptions = () =>
  instance.get(
    `${apiUrls.REDEMPTION}?perPage=100&sort=date&sortBy=DESC&checkRemain=1&productBranchId=${store.getters.selectedBranch.id}&includeSharing=1`
  );

// not support filter by branch, defined for eStore - used on after successfully gateway payment page where user can directly redemption purchase items
const getRedemptionsByTicket = (ticketId) =>
  instance.get(
    `${apiUrls.REDEMPTION}?perPage=50&sort=date&sortBy=DESC&checkRemain=1&ticketId=${ticketId}`
  );

export {
  getRedemptions,
  getRedemptionsByTicket,
};
